export type ServiceDetailFeature = {
  title: string;
  text: string;
};

export type ServiceDetailDeepDive = {
  benefitsFor: string[];
  featureCards: ServiceDetailFeature[];
  highlightBullets: string[];
  intro: string;
  introTitle: string;
  title: string;
  whatIs: string;
  whatIsTitle: string;
};

export const serviceDetailContentBySlug: Record<string, ServiceDetailDeepDive> = {
  "care-coordinator-services": {
    benefitsFor: [
      "Senior citizens requiring ongoing care support",
      "Individuals with chronic health conditions",
      "Patients recovering from surgery or hospitalization",
      "Families managing healthcare remotely",
      "Individuals requiring multiple healthcare services",
    ],
    featureCards: [
      {
        title: "Personalized Care Planning",
        text: "We assess individual health needs and create customized care plans tailored to specific medical and personal requirements.",
      },
      {
        title: "Appointment Management",
        text: "Scheduling and coordinating doctor visits, nursing services, diagnostic tests, and follow-up consultations.",
      },
      {
        title: "Healthcare Navigation",
        text: "Helping patients and families understand treatment plans, healthcare options, and available support services.",
      },
      {
        title: "Care Provider Coordination",
        text: "Connecting and coordinating with doctors, nurses, physiotherapists, caregivers, and other healthcare professionals.",
      },
      {
        title: "Health Monitoring & Follow-ups",
        text: "Regular check-ins to track progress, monitor health conditions, and ensure adherence to care plans.",
      },
      {
        title: "Medication & Wellness Reminders",
        text: "Timely reminders for medications, appointments, vaccinations, and preventive health checkups.",
      },
      {
        title: "Family Communication",
        text: "Keeping family members informed with updates, care progress reports, and important healthcare information.",
      },
      {
        title: "Emergency Support Coordination",
        text: "Assisting families in arranging appropriate care and support during urgent situations.",
      },
    ],
    highlightBullets: [
      "Dedicated Point of Contact",
      "Personalized Care Management",
      "Seamless Healthcare Coordination",
      "Trusted Healthcare Network",
      "Regular Follow-ups and Monitoring",
      "Family Peace of Mind",
      "Compassionate and Professional Support",
    ],
    intro:
      "Managing healthcare can be overwhelming, especially for seniors and families balancing multiple appointments, treatments, and care providers. Carevinco's Care Coordinators simplify the process by serving as your dedicated partner, ensuring every aspect of care is organized, seamless, and personalized.",
    introTitle: "Your Personal Guide to Better Care",
    title: "Care Coordinator Service Experience",
    whatIs:
      "A Care Coordinator is a trained professional who helps individuals and families navigate their healthcare journey. They act as a central point of contact, coordinating services, scheduling appointments, monitoring care plans, and ensuring that healthcare needs are met efficiently.",
    whatIsTitle: "What is a Care Coordinator?",
  },
};
